import {BaseValidatedClass} from './BaseValidatedClass';
import {AiAssistantValueType} from './constants/AiAssistantValueType';

interface ExternalAiAssistantMap {
  openAiAssistant(_params: {
    value: string;
    onDataSelectCallback: ExternalAiAssistantCallback;
    onCancelCallback: ExternalAiAssistantCancelCallback;
    type: AiAssistantValueType;
  }): void;
}

export type ExternalAiAssistantCallback = (html: string) => void;
export type ExternalAiAssistantCancelCallback = () => void;
export class ExternalAiAssistant extends BaseValidatedClass implements ExternalAiAssistantMap {
  /** List of methods that must be implemented by subclasses */
  private static readonly REQUIRED_METHODS: (keyof ExternalAiAssistantMap)[] = ['openAiAssistant'];

  constructor() {
    super(ExternalAiAssistant.REQUIRED_METHODS, ExternalAiAssistant);
  }

  public openAiAssistant(
    _options: {
      value: string;
      onDataSelectCallback: ExternalAiAssistantCallback;
      onCancelCallback: ExternalAiAssistantCancelCallback;
      type: AiAssistantValueType;
    }): void {
    throw new Error('Method openAiAssistant() must be implemented by the subclass');
  }
}
